import { Meta, Title } from "react-head";

import React from "react";

const Seo = () => (
  <>
    <Title>SphericMed | Balance Is Everything!</Title>
    <Meta name="description" content="Balance Is Everything!" />
    <meta name="facebook-domain-verification" content="on4b77ecesf3fsh86le77r1pupxepu"/>
     <meta property="og:image" content="/images/slide-1.jpg" data-react-helmet="true" />
  </>
);

export default Seo